import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PreviewDataWrapperComponent } from '../../preview-data-wrapper/preview-data-wrapper.component';
import { Beneficjent } from '../../../models/beneficjent';

@Component({
  selector: 'app-preview-contact-details',
  imports: [PreviewDataWrapperComponent],
  templateUrl: './preview-contact-details.component.html',
  styleUrl: './preview-contact-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewContactDetailsComponent {
  public beneficiary = input.required<Beneficjent>();
}
